var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49978 4.8291C6.5577 4.8291 5.79199 5.59552 5.79199 6.5376C5.79199 7.47898 6.5577 8.24468 7.49978 8.24468C8.44187 8.24468 9.20828 7.47898 9.20828 6.5376C9.20828 5.59552 8.44187 4.8291 7.49978 4.8291ZM7.49978 9.30718C5.97191 9.30718 4.72949 8.06477 4.72949 6.5376C4.72949 5.00973 5.97191 3.7666 7.49978 3.7666C9.02766 3.7666 10.2708 5.00973 10.2708 6.5376C10.2708 8.06477 9.02766 9.30718 7.49978 9.30718Z",
    fill: "#C2C2C2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12442_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416992 0.833496H14.5836V12.2412H0.416992V0.833496Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12442_570)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5289 6.53704C2.8464 9.44758 5.06561 11.178 7.50015 11.1787C9.93469 11.178 12.1539 9.44758 13.4714 6.53704C12.1539 3.62721 9.93469 1.89675 7.50015 1.89604C5.06631 1.89675 2.8464 3.62721 1.5289 6.53704V6.53704ZM7.50156 12.2412H7.49873H7.49802C4.56836 12.2391 1.93761 10.1857 0.460023 6.74671C0.402648 6.61283 0.402648 6.46125 0.460023 6.32737C1.93761 2.88912 4.56906 0.835664 7.49802 0.833539C7.49944 0.832831 7.49944 0.832831 7.50015 0.833539C7.50156 0.832831 7.50156 0.832831 7.50227 0.833539C10.4319 0.835664 13.0627 2.88912 14.5403 6.32737C14.5984 6.46125 14.5984 6.61283 14.5403 6.74671C13.0634 10.1857 10.4319 12.2391 7.50227 12.2412H7.50156Z",
    fill: "#C2C2C2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSmall);
export default __webpack_public_path__ + "static/media/eye-small.c6a75086b1aedb2d98fb1c1146dd7725.svg";
export { ForwardRef as ReactComponent };